import {
  useApplyVideoObjectFit,
  useAudioVideo,
  useLocalVideo,
} from 'amazon-chime-sdk-component-library-react'
import { useEffect, useRef } from 'react'
import { useShallow } from 'zustand/shallow'
import { MeetingState, useMeetingStore } from '../../context/MeetingState'
import { DeprecatedVideoTile, DeprecatedVideoTileProps } from './DeprecatedVideoTile'

export type LocalVideoProps = {
  id?: string
  isActiveVideo?: boolean
} & DeprecatedVideoTileProps

export function LocalVideo({ isActiveVideo, ...props }: LocalVideoProps) {
  const { tileId, isVideoEnabled } = useLocalVideo()
  const audioVideo = useAudioVideo()
  const videoEl = useRef<HTMLVideoElement>(null!)
  useApplyVideoObjectFit(videoEl)

  useEffect(() => {
    if (!audioVideo || !tileId || !videoEl.current || !isVideoEnabled) {
      return
    }

    audioVideo.bindVideoElement(tileId, videoEl.current)

    return () => {
      const tile = audioVideo.getVideoTile(tileId)
      if (tile) {
        audioVideo.unbindVideoElement(tileId)
      }
    }
  }, [audioVideo, tileId, isVideoEnabled])

  const chimeAttendee = useMeetingStore(useShallow(stateSelector))

  return (
    <DeprecatedVideoTile
      ref={videoEl}
      attendeeId={chimeAttendee?.AttendeeId}
      id="local"
      isActiveVideo={isActiveVideo}
      tileId={tileId === null ? undefined : tileId}
      {...props}
    />
  )
}

const stateSelector = (state: MeetingState) => state.chimeAttendee
